<template>
  <div class="use-header" style="background: #FFFFFF;">
    <div style="display:flex;align-items: center;">
      <div class="user-info"></div>
      <div style="display: flex;align-items: center">
        <a-menu mode="horizontal">
          <a-sub-menu>
            <span slot="title" class="submenu-title-wrapper">
              <svg-setting-two
                theme="outline"
                size="18"
                fill="#0A5BA8"
                style="vertical-align: middle"
              />&nbsp;&nbsp;{{ orgName }}
            </span>
            <a-menu-item key="ChangePass" @click="handleChangePass"
              >修改密码</a-menu-item
            >
            <a-menu-item key="logout" @click="signOut">退出登录</a-menu-item>
          </a-sub-menu>
          ({{ userName }})
        </a-menu>


        <!--        <a-icon :type="isfullScreen?'fullscreen-exit':'fullscreen'" style="font-size: 20px" @click="handleZoom" class="Screenfullbtn"/>-->
<!--        <message-outlined-->
<!--          theme="outline"-->
<!--          size="24"-->
<!--          fill="#0A5BA8"-->
<!--        />-->
         <svg-full-screen-one
          theme="outline"
          size="24"
          fill="#0A5BA8"
          class="Screenfullbtn"
          @click="handleZoom"
          v-if="!isfullScreen"
        />
        <svg-off-screen-one
          theme="outline"
          size="24"
          fill="#0A5BA8"
          class="Screenfullbtn"
          @click="handleZoom"
          v-else
        />
        <a-badge class="notice-badge" :count="msgSize" :overflow-count="99">
        <header-notice class="header-item"/>
        </a-badge>
      </div>
    </div>
    <mod-password
      ref="modPassword"
      :modal-show="modalShowVisable"
      :modal-pass-title="modaPasslTitle"
      :passloading="passloading"
      :modal-pass-width="700"
      @handlePassOk="handlePassOk"
      @handlePassCancel="handlePassCanceled"
      :form-val="passform"
    >
    </mod-password>
  </div>
</template>
<script>
import ModPassword from "@/components/ModPassword.vue";
import  MessageOutlined from '@ant-design/icons-vue';
import HeaderNotice from './layout/header/HeaderNotice'
import hexMd5 from "js-md5";
import moment from "moment";

export default {
  name: "UserHeader",

  mounted() {
    this.timer = setInterval(this.getMessageInfo, 300000);
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },

  data() {
    return {
      timer: null,
      modalShowVisable: false,
      passloading: false,
      modaPasslTitle: "修改密码",
      IsmodifyMyPassword: true,
      passform: {},
      key3: "",
      userName: "",
      orgName: "",

      msgSize:0,
      collapsed: false
    };
  },
  props: {
    isfullScreen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ModPassword,
    HeaderNotice,
    MessageOutlined
  },
  methods: {
    logding() {},
    handleZoom() {
      this.$emit("handleZoom");
    },

    handlePassCanceled(ref) {
      this.passform = {};
      ref.resetFields();
      this.modalShowVisable = false;
    },
    handlePassOk(e) {
      const session = JSON.parse(sessionStorage.getItem("unInfo"));
      this.key3 = session.key;
      e.validate(valid => {

        if (valid) {
          const uri = "personalPassword";
          let account = JSON.parse(sessionStorage.getItem("key"));
          // 加密密码
          const oldPwd = hexMd5(
            `${account}${hexMd5(this.passform["oldPassword"])}`
          );
          const params = {};
          params.oldPwd = this.des3Encrypt(this.key3, oldPwd);
          const newPwd = hexMd5(
            `${account}${hexMd5(this.passform["password"])}`
          );
          params.newPwd = this.des3Encrypt(this.key3, newPwd);
          this.$json(uri, params)
            .then(response => {
              // this.$router.push("/Login");
              this.$message.success("修改密码成功");
              this.showModifyPassword = false;
              this.modalShowVisable = false;
              setTimeout(() => {
                this.signOut();
              }, 1000);
            })
            .catch(e => {
              this.$message.error(e.message);
            });
        } else {
          return false;
        }
      });
    },
    signOut() {
      this.$json("logout")
        .then(result => {
          window.sessionStorage.clear();
          location.reload();
          // this.$router.push({ name: "Login" });
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: "warning"
          });
        });
    },

    handleChangePass() {
      this.modalShowVisable = true;
      this.passform = {};
      this.$forceUpdate();
    },

    handleUser(e) {
      window.less
        .modifyVars({
          "@primary-color": this.color,
          "@link-color": this.color,
          "@btn-primary-bg": this.color
        })
        .then(() => {})
        .catch(error => {
          alert("失败");
        });

      //   const lessStyleNode = document.createElement('link');
      //   const lessConfigNode = document.createElement('script');
      //   const lessScriptNode = document.createElement('script');
      //   lessStyleNode.setAttribute('rel', 'stylesheet/less');
      //   lessStyleNode.setAttribute('href',  '@.../../../color.less');
      //
      //   lessConfigNode.innerHTML = `
      //   window.less = {
      //     async: true,
      //     env: 'production',
      //     javascriptEnabled: true
      //   };
      // `;
      //
      //   lessScriptNode.src = 'https://cdnjs.cloudflare.com/ajax/libs/less.js/2.7.2/less.min.js';
      //   lessScriptNode.async = true;
      //   lessScriptNode.onload = () => {
      //     const windowless=window;
      //     if (!windowless.less || !windowless.less.modifyVars) {
      //       return;
      //     }
      //     if(e.key=='ChangeColor'){
      //       this.IsChangeColor=!this.IsChangeColor
      //       let color='#FFFFFF';
      //       // const windowless:any=window;
      //
      //       if(!this.IsChangeColor){
      //         // color='#1f528c'
      //         // this.changeColor(color);
      //         // #945305
      //         windowless.less.modifyVars({
      //           '@primary-color': '#74afd9',
      //           '@link-color': '#74afd9',
      //           '@btn-primary-bg': '#945305',
      //           '@layout-header-background':color,
      //           '@layout-body-background':'#1e3e64',
      //           '@body-background':color,
      //           '@header-background':'red',
      //           "@text-color":'#FFFFFF',
      //           '@text-color-secondary':'#FFFFFF',
      //           '@menu-item-select':'rgba(108, 164, 205, 0.15)',
      //           '@ant-table-tbody-border':'#295d9a',
      //
      //           // "@body-background2":"#FFFFFF",
      //           "@heading-color":'#579ac8'
      //         }).then((res) => {
      //         }).catch(error => {
      //           alert('失败')
      //         })
      //       }
      //
      //       else{
      //         color='#FFFFFF'
      //         // this.changeColor(color)
      //         windowless.less.modifyVars({
      //           '@primary-color': '#40a9ff',
      //           '@link-color': '#40a9ff',
      //           '@btn-primary-bg': '#40a9ff',
      //           '@layout-header-background':'#00ac97',
      //           '@layout-body-background':color,
      //           "@heading-color":'black',
      //           '@ant-table-tbody-border':'#e4e7eb',
      //         }).then((res) => {
      //         }).catch(error => {
      //           alert('失败')
      //         })
      //       }
      //     }
      //
      //     lessScriptNode.onload = null;
      //     return true
      //   };
      //   document.body.appendChild(lessStyleNode);
      //   document.body.appendChild(lessConfigNode);
      //   document.body.appendChild(lessScriptNode);
    },
    getMessageInfo(){
      console.log("&&&&&&&&&&&&&getMessageInfo");
      const params = {
        url:"queryMsgSysmsg",
        query:{readFlag: 0,
          pageSize: 1,
          pageNo: 10}
      };
      this.$json(params.url, params.query).then(response => {
        const {total,record} = response;
        if(total == 0){

          // this.loadingMore = true;
          return false;
        }

        this.msgSize = total
      });

    },
    aaa() {
      const lessStyleNode = document.createElement("link");
      const lessConfigNode = document.createElement("script");
      const lessScriptNode = document.createElement("script");
      lessStyleNode.setAttribute("rel", "stylesheet/less");
      // @../../../color.less
      lessStyleNode.setAttribute("href", "../../public/color.less");
      lessConfigNode.innerHTML = `window.less = {
        async: true,
        env: 'production',
        javascriptEnabled: true
      };`;
      lessScriptNode.src =
        "https://cdnjs.cloudflare.com/ajax/libs/less.js/2.7.2/less.min.js";
      lessScriptNode.async = true;
      lessScriptNode.onload = () => {
        let color = "#FFFFFF";
        const windowless = window;
        if (!windowless.less || !windowless.less.modifyVars) {
          return;
        }
        color = "#FFFFFF";
        windowless.less
          .modifyVars({
            "@primary-color": "#40a9ff",
            "@link-color": "#40a9ff",
            "@btn-primary-bg": "#40a9ff",
            "@layout-header-background": "#00ac97",
            "@layout-body-background": color,
            "@menu-item-select": "rgba(108, 164, 205, 0.15)",
            "@ant-table-tbody-border": "#e4e7eb",
            "@heading-color": "black"
          })
          .then(res => {})
          .catch(error => {
            alert("失败");
          });
        // buildIt();
        // const windowless:any=window;
        // 正确的判定less是否已经加载less.modifyVars可用
        // less.modifyVars可用
        lessScriptNode.onload = null;
        return true;
      };
      document.body.appendChild(lessStyleNode);
      document.body.appendChild(lessConfigNode);
      document.body.appendChild(lessScriptNode);
    }
  },
  created() {
    // this.aaa();
    let userInfoStr = sessionStorage.getItem("unInfo");
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr);
      this.userName = userInfo.user.orgName;
      this.orgName = userInfo.user.nickname;
      // const paramsq = { orgId: userInfo.user.orgId };
      // const uri = "loginInformation";

      // this.$json(uri, paramsq).then(response => {
      //   this.orgName = response.orgName;
      // });
    }
    this.getMessageInfo();
  },
  beforeUpdate() {
    console.log("#######################getMessageInfo");
    this.getMessageInfo();
  },

};
</script>

<style scoped>
/deep/ .ant-menu-item {
  width: 90px !important;
  height: 26px !important;
  line-height: 26px !important;
  margin: 0 !important;
  padding: 0 8px !important;
}

/deep/ .ant-menu-submenu > .ant-menu {
  width: 100px;
  min-width: 100px;
}
.nav-menu {
  width: 200px;
  height: 300px;
}
.Screenfullbtn {
  cursor: pointer;
  margin-left: 20px;
}
.use-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
}

h1 {
  margin-bottom: 0;
  color: #fff;
}

.ant-dropdown-trigger {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/UserHeader.vue